import { helper } from '@ember/component/helper';
import * as Format from '../utils/format';

export function formatValue(params, namedArgs) {
  let result = Format.formatFieldValue(namedArgs.value, namedArgs.fieldType, namedArgs.param);
  return result;
}

export default helper(formatValue);
